import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'

import { pageTypes } from '@/config'
import { PageLink } from '@/entities/webapp-pages/page-types/Link'
import { PageService } from '@/entities/webapp-pages/page-types/Service'
import { PageNavigation } from '@/entities/webapp-pages/page-types/Navigation'
import { PageContent } from '@/entities/webapp-pages/page-types/Content'
import { getFileURL } from '@/lib/helpers/FileURLGetter'
import { isURL } from '@/lib/helpers/FormValidation'

export class WebappPage {
  constructor (params = {}) {
    params = camelcaseKeys(params, { deep: true })
    const { id, type, updatedAt, active, coverImageFileId, icon, facilityId } = params.webappPage ? params.webappPage : params
    this.id = id || null
    this.type = type || null
    this.coverImageFileId = coverImageFileId || null
    this.icon = icon || null
    if (this.icon && this.icon.split('-')[0] !== 'mdi') {
      if (isURL(this.icon)) {
        this.iconUrl = this.icon
      } else {
        this.iconUrl = getFileURL(this.icon)
      }
    } else {
      this.iconUrl = null
    }
    this.updatedAt = updatedAt || null
    this.active = active
    this.coverImageUrl = this.coverImageFileId ? getFileURL(this.coverImageFileId) : null
    this.facilityId = facilityId || null

    switch (this.type) {
    case pageTypes.LINK:
      this.pageSpecific = new PageLink(params)
      break
    case pageTypes.SERVICE:
      this.pageSpecific = new PageService(params)
      this.relatedPages = this.pageSpecific.relatedPages
      this.linkedContent = this.pageSpecific.linkedContent
      this.reservationMethods = this.pageSpecific.reservationMethods
      break
    case pageTypes.NAVIGATION:
      this.pageSpecific = new PageNavigation(params)
      break
    case pageTypes.CONTENT:
      this.pageSpecific = new PageContent(params)
      this.buttons = this.pageSpecific.buttons
      this.relatedPages = this.pageSpecific.relatedPages
      this.linkedContent = this.pageSpecific.linkedContent
      break
    default:
      break
    }
  }
  serialize (editedFields) {
    const page = JSON.parse(JSON.stringify(this))

    Object.keys(editedFields).forEach(key => {
      if (['button', 'navigation'].includes(key)) {
        Object.keys(editedFields[key]).forEach(subKey => {
          page[key][subKey] = editedFields[key][subKey]
        })
      } else {
        page[key] = editedFields[key]
      }
    })

    return snakecaseKeys(page)
  }
}
